/**
 * DemoConfig — centralized demo mode configuration.
 *
 * When REACT_APP_DEMO_MODE=true (set in Cloudflare production env vars),
 * the game is limited to level 1 only. Payments, wallet connect, epochs,
 * and progression are disabled. A feedback button and "IN DEVELOPMENT"
 * messaging are shown instead.
 *
 * Remove the env var (or set to 'false') to enable full game.
 */

const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === "true";

const DemoConfig = {
  isDemoMode() {
    return DEMO_MODE;
  },

  /** Maximum level a player can reach in demo mode */
  MAX_LEVEL: 1,

  /** Whether wallet/payment features are enabled */
  paymentsEnabled() {
    return !DEMO_MODE;
  },

  /** Whether epoch pot display is shown */
  epochDisplayEnabled() {
    return !DEMO_MODE;
  },

  /** Whether the CONTINUE button should appear */
  continueEnabled() {
    return !DEMO_MODE;
  },

  /** Whether daily challenge is available */
  dailyChallengeEnabled() {
    return !DEMO_MODE;
  },
};

export default DemoConfig;
